import AppHeader from '../AppHeader'
var $ = require('jquery')
export default {
  name: 'stock-output',
  data () {
    return {
      orderMethod: '',
      remark: ''
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async output () {
      if (this.orderMethod == 'tanomail') {
        this.tanomailOutput()
      } else {
        this.pdfOutput()
      }
    },
    async tanomailOutput () {
      let data = {
        order_method: this.orderMethod
      }
      let res = await this.$store.dispatch('STOCK_OUTPUT_TANOMAIL', data)
                .catch(err => {
                  console.log(err)
                  return
                })
      this.tanomailCsv(res.tsv_data)
    },
    tanomailCsv (data) {
      let wkFileName = 'たのめーる一括発注.txt'
      const tsvFileName = wkFileName
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/plain'
      let tsv = ''
      data.forEach(obj => {
        if (obj.represent_code) {
          tsv += this.enquoteForTSV(obj.represent_code) + '\t'
        } else {
          tsv += '\t'
        }
        if (obj.group_code) {
          tsv += this.enquoteForTSV(obj.group_code) + '\t'
        } else {
          tsv += '\t'
        }
        if (obj.login_id) {
          tsv += this.enquoteForTSV(obj.login_id) + '\t'
        } else {
          tsv += '\t'
        }
        if (obj.product_code) {
          tsv += this.enquoteForTSV(obj.product_code) + '\t'
        } else {
          tsv += '\t'
        }
        if (obj.order_lot_quantity) {
          tsv += this.enquoteForTSV(obj.order_lot_quantity) + '\t'
        } else {
          tsv += '\t'
        }
        tsv += '\t'
        tsv += '\t'
        if (obj.management_number) {
          tsv += this.enquoteForTSV(obj.management_number) + '\t'
        } else {
          tsv += '\t'
        }
        tsv += '\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t'
        if (obj.receive_responsible) {
          tsv += this.enquoteForTSV(obj.receive_responsible)
        }
        tsv += '\n'
      })
      const blob = new Blob([bom, tsv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = tsvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, tsvFileName)
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(
          blob
        )
        hiddenElement.click()
      }
    },
    enquoteForTSV: function (val) {
      if (!val) return val
      if (/["\r\n]/.test(val)) {
        // "\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    },
    async pdfOutput () {
      $('#stockOutput').modal('hide')
      let data = {
        order_method: this.orderMethod,
        remark: this.remark
      }
      let res = await this.$store.dispatch('STOCK_OUTPUT_PDF', { data: data })
                .catch(err => {
                  console.log(err)
                  return
                })
      let link = document.createElement('a')
      let pdfFileName = '一括発注.pdf'
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])

      const blob = new Blob([bom, res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/pdf' })

      link.style = 'display: none'
      link.download = pdfFileName
      link.target = '_blank'

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, pdfFileName)
      } else if (window.URL && window.URL.createObjectURL) {
        link.href = window.URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        link.href = (window.URL || window.webkitURL).createObjectURL(blob)
        link.click()
      }
    },
    outputClick () {
      if (this.orderMethod !== 'tanomail') {
        $('#stockOutput').modal()
      } else {
        this.output()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stock-output.js